/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DressingMode = 'MIXED' | 'NOT_DRESSABLE' | 'ON_THE_SIDE' | 'REMOVED';

export type DressingWeight = 'HEAVY' | 'LIGHT' | 'MEDIUM';

export type IngredientKind = 'BASE' | 'DRESSING' | 'PREMIUM' | 'TOPPING';

export type OrdersInputV2 = {
  readonly includeCanceledOrders?: boolean | null | undefined;
  readonly includePlacedOrders?: boolean | null | undefined;
  readonly page: number;
  readonly take: number;
};

export type ReorderOrderFragment = {
  readonly __typename: 'Order';
  readonly id: string;
  readonly wantedTime: string;
  readonly deliveryOrderDetail: {
    readonly __typename: 'DeliveryOrderDetail';
    readonly id: string;
    readonly deliveryFee: number;
    readonly tip: number;
    readonly vendor: string;
    readonly vendorRestaurantId: string;
    readonly address: {
      readonly __typename: 'Address';
      readonly id: string;
      readonly name: string | null;
    } | null;
  } | null;
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
  };
  readonly lineItems: ReadonlyArray<{
    readonly __typename: 'LineItem';
    readonly id: string;
    readonly customName: string | null;
    readonly dressingMode: Types.DressingMode;
    readonly orderParticipant: { readonly id: string; readonly isMe: boolean } | null;
    readonly mixedDressingDetails: ReadonlyArray<{
      readonly weight: Types.DressingWeight;
      readonly ingredientId: string;
    }>;
    readonly removedIngredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
    }>;
    readonly addedIngredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
    }>;
    readonly product: {
      readonly __typename: 'Product';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly isCustom: boolean;
      readonly enableDressingDetails: boolean;
      readonly categoryName: string;
      readonly asset: { readonly url: string };
      readonly ingredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly kind: Types.IngredientKind | null;
      }>;
    };
  }>;
};

export type OrdersV2ForReorderQueryVariables = Exact<{
  input: Types.OrdersInputV2;
}>;

export type OrdersV2ForReorderQuery = {
  readonly ordersV2:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly pagination: { readonly total: number; readonly last: number };
        readonly orders: ReadonlyArray<{
          readonly __typename: 'Order';
          readonly id: string;
          readonly wantedTime: string;
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly deliveryFee: number;
            readonly tip: number;
            readonly vendor: string;
            readonly vendorRestaurantId: string;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly name: string | null;
            } | null;
          } | null;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly customName: string | null;
            readonly dressingMode: Types.DressingMode;
            readonly orderParticipant: { readonly id: string; readonly isMe: boolean } | null;
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly weight: Types.DressingWeight;
              readonly ingredientId: string;
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
            }>;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly slug: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly enableDressingDetails: boolean;
              readonly categoryName: string;
              readonly asset: { readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
          }>;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const ReorderOrderFragmentDoc = gql`
  fragment ReorderOrder on Order {
    id
    __typename
    wantedTime
    deliveryOrderDetail {
      id
      __typename
      address {
        id
        __typename
        name
      }
      deliveryFee
      tip
      vendor
      vendorRestaurantId
    }
    restaurant {
      id
      __typename
      slug
    }
    lineItems {
      id
      __typename
      customName
      orderParticipant {
        id
        isMe
      }
      mixedDressingDetails {
        weight
        ingredientId
      }
      removedIngredients {
        id
        __typename
        name
        kind
      }
      addedIngredients {
        id
        __typename
        name
        kind
      }
      dressingMode
      product {
        id
        __typename
        slug
        name
        isCustom
        enableDressingDetails
        categoryName
        asset {
          url
        }
        ingredients {
          id
          __typename
          kind
        }
      }
    }
    restaurant {
      id
      __typename
      name
    }
  }
`;
export const OrdersV2ForReorderDocument = gql`
  query ordersV2ForReorder($input: OrdersInputV2!) {
    ordersV2(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        pagination {
          total
          last
        }
        orders {
          ...ReorderOrder
        }
      }
      ... on ValidationError {
        fieldErrors {
          field
          message
        }
      }
    }
  }
  ${ReorderOrderFragmentDoc}
`;

export function useOrdersV2ForReorderQuery(
  options: Omit<Urql.UseQueryArgs<OrdersV2ForReorderQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrdersV2ForReorderQuery, OrdersV2ForReorderQueryVariables>({
    query: OrdersV2ForReorderDocument,
    ...options,
  });
}
